import { BASE_URL } from '../Api';
import { Helmet, HelmetProvider } from "react-helmet-async";
import FreeHighlight from '../partials/FreeHighlight';
import { PluginDownloadButtons } from '../partials';

const ExpirationDatePlugin = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Expiration date - Aronium</title>
          <meta name="description" content="Track expiration date of your products" />
        </Helmet>
      </HelmetProvider>

      <section className="py-8 max-w-screen-xl px-4 mx-auto">
        <div className="max-w-screen-xl mx-auto text-center">
          <h1 className="text-4xl mb-4">
            Stay ahead with expiration date tracking
          </h1>
          <p>
            The Expiration date plugin enables efficient tracking of product expiration dates
          </p>

          {/* Call to Action Buttons */}
          <PluginDownloadButtons
            liteUrl={`${BASE_URL}/plugins/expiration-date/latest/Aronium.Pos.ExpirationDate.Lite.exe`}
            proUrl={`${BASE_URL}/plugins/expiration-date/latest/Aronium.Pos.ExpirationDate.Pro.exe`}/>
        </div>
      </section>

      {/* Overview Section */}
      <div className="flex flex-col text-center mt-10 px-4">
        <div className="grid place-content-center justify-items-center">
          <img src="/images/expiration-date-report.png" className='border-t-8 border-l border-r rounded-t-xl border-solid border-[#8E5D3C] xl:max-w-6xl' alt="Expiration date screen" />
        </div>
      </div>
      <div className="bg-gray-100 py-20">
        <div className="relative max-w-7xl mx-auto text-center px-8 lg:px-12">
          <h2 className="text-5xl text-gray-800 leading-tight mb-8">
            Why use the <span className='font-semibold'>Expiration Date</span> plugin?
          </h2>
          <p className="text-lg text-gray-600 max-w-5xl mx-auto">
            This plugin allows you to generate reports listing items that are approaching their expiration within a specified timeframe, helping you manage inventory effectively and enhance customer service.          </p>
        </div>
        <FreeHighlight className="mt-12" />
      </div>

      {/* Key Features Section */}
      <div className="py-24">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          <div className="bg-white p-8 shadow-lg rounded-lg border border-gray-200">
            <h3 className="text-2xl font-semibold text-gray-800">
              Add expiration date to purchase
            </h3>
            <p className="mt-4 text-gray-600">
              When adding products in a purchase document, users can specify the expiration date for each item.
            </p>
          </div>
          <div className="bg-white p-8 shadow-lg rounded-lg border border-gray-200">
            <h3 className="text-2xl font-semibold text-gray-800">
              Expiration date reporting
            </h3>
            <p className="mt-4 text-gray-600">
              The plugin offers a report that lists products with their expiration dates within a selected period.
            </p>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="bg-gradient-to-tr from-[#5e3f2b] to-[#cfa98a] py-24 text-center text-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-6xl mb-6">
            Never miss an expiry again!
          </h2>
          <p className="text-xl mb-10">
            Start using the <span className='font-semibold'>Expiration Date</span> plugin and take control of your product shelf life
          </p>
          <a
            href="https://help.aronium.com/hc/en-us/articles/21980187500178-Add-expiration-date"
            className="button-rounded-white px-12 py-4"
            target="_blank"
            rel="noreferrer">
            Learn more <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="ml-2 w-6 h-6 transition-all">
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
            </svg>
          </a>
        </div>
      </div>
    </>
  );
};

export default ExpirationDatePlugin;
